import axios from "axios";
import configExample from "../config/config.example.json";

export const makeGetConfigRequest = async () => {
  if (process.env.NODE_ENV !== "production")
    return Promise.resolve(configExample);
  const config = await axios.get("/config.json");
  return config.data;
};
